import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Transition } from '@headlessui/react';

function DropdownPanel({ show, children }) {
  return (
    <div className="relative inline-block text-left w-full">
      <Transition
        as={Fragment}
        show={show}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <div className="origin-top absolute right-0 mt-2 w-full rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none">
          <div className="p-4">{children}</div>
        </div>
      </Transition>
    </div>
  );
}

DropdownPanel.propTypes = {
  show: PropTypes.bool.isRequired,
  children: PropTypes.instanceOf(Object).isRequired,
};

export default DropdownPanel;
